import { useEffect, useContext } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ColorModeContext } from '../theme';

/**
 * Bridge component that connects AuthContext and ColorModeContext.
 * Registers a callback with AuthContext to reload theme from backend after login.
 */
const ThemeAuthBridge = ({ children }) => {
  const { registerLoginCallback } = useAuth();
  const colorMode = useContext(ColorModeContext);

  useEffect(() => {
    // Register callback to reload theme when user logs in
    const unregister = registerLoginCallback((preferences) => {
      if (preferences?.theme && colorMode?.setMode) {
        colorMode.setMode(preferences.theme);
      }
    });

    // Cleanup on unmount
    return unregister;
  }, [registerLoginCallback, colorMode]);

  return children;
};

export default ThemeAuthBridge;
